import volunteerLocales from './volunteerLanguages.json'
import { supportConfig } from '../../config'

export const supportedLanguages = () =>
  volunteerLocales
    .filter((locale) => supportConfig.chatLocales.includes(locale.locale))
    .sort((a, b) => a.category.localeCompare(b.category))

export default supportedLanguages
